import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL
});

// ✅ Carrega token salvo no localStorage (se existir)
const token = localStorage.getItem('token');
if (token) {
  api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
}

// ✅ Interceptor de requisição (garante que o token seja enviado)
api.interceptors.request.use(config => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// ✅ Interceptor de resposta (detecta 401 e faz logout automático)
api.interceptors.response.use(
  response => response,
  error => {
    if (error.response && error.response.status === 401) {
      // limpa token e usuário
      localStorage.removeItem('token');
      localStorage.removeItem('usuario');

      // redireciona para login
      window.location.hash = '#/login';
    }
    return Promise.reject(error);
  }
);

export default api;
